import {
    AUTH_SUCCESS, AUTH_FAIL, LOGOUT, SYNC_USER,
    ADD_TO_CART, REMOVE_FROM_CART, CART_LOADING,
    ADD_ADDRESS, REMOVE_ADDRESS
} from './type'
import { v4 as uuidv4 } from 'uuid'
import firebase, { firestore, functions } from '../utils/firebase'
import { openAuthModal, closeAuthModal, openUpdateProfileModal, closeUpdateProfileModal } from './metaAction'

import { openBulkOrderPopUp } from './metaAction'

// ===================================
// ==== initalizing functions here
// ===================================
const addToCartFunc = functions.httpsCallable('addToCart')
const removeFromCartFunc = functions.httpsCallable('removeFromCart')


export const sendEmail = () => {
    const user = firebase.auth().currentUser

    if (user.email && !user.emailVerified) {
        user.sendEmailVerification()
    }

}

export const setUser = user => async dispatch => {
    const uid = user.uid

    dispatch({
        type: AUTH_SUCCESS,
        payload: uid
    })

    dispatch(closeAuthModal())

    if (!Boolean(user.displayName) || !Boolean(user.email)) {
        dispatch(openUpdateProfileModal())
    }

    try {
        const docRef = firestore.collection('user').doc(uid)
        docRef.onSnapshot(function (doc) {
            if (doc.data()) {
                const latestData = doc.data()
                const latestCart = latestData['cart']
                delete latestData['cart']
                dispatch({
                    type: SYNC_USER,
                    payload: { profile: latestData, cart: latestCart }
                })

                if (user.emailVerified === true && latestData.emailVerified === false) {
                    docRef.update({ emailVerified: true })
                }


            }
        });

    } catch (error) {
        dispatch({
            type: AUTH_FAIL
        })
        if (error.message) {
            window.alert(error.message)
        } else {
            window.alert('something went wrong')
        }
        console.log(error)
    }

};


export const updateProfile = ({ full_name, email }) => (dispatch, getState) => {
    if (!getState().user.isAuthenticated) {
        dispatch(openAuthModal())
        return
    }

    const currentUser = firebase.auth().currentUser


    currentUser.updateProfile({
        displayName: full_name
    }).then(() => {
        firestore.collection('user').doc(currentUser.uid).update({
            full_name
        })
    })

    currentUser.updateEmail(email).then(e => {
        firestore.collection('user').doc(currentUser.uid).update({
            full_name,
            email
        }).then(() => {
            sendEmail()
            dispatch(closeUpdateProfileModal())
        })

    }).catch(error => {
        if (error.message) {
            window.alert(error.message)
        } else {
            window.alert('something went wrong')
        }
        console.log(error)
    })


}


export const cartLoading = () => {
    return {
        type: CART_LOADING
    }
}

const isArrayEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false
    if (arr1 == null || arr1 == null) return false;

    arr1.sort()
    arr2.sort()

    for (var i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;

}

const localAddToCart = item => (dispatch, getState) => {

    let cart = { ...getState().user.cart }

    let foundItemArray = cart[item.id] || []

    for (let i = 0; i < foundItemArray.length; i++) {
        const currentConfig = foundItemArray[i];
        const foundItemCustomization = Object.keys(currentConfig.customization)
        const itemCustomization = Object.keys(item.customization)
        if (isArrayEqual(foundItemCustomization, itemCustomization)) {
            currentConfig.quantity = currentConfig.quantity + 1

            return dispatch({
                type: ADD_TO_CART,
                payload: cart
            })

        }
    }

    const newId = uuidv4()

    cart = { ...cart, [item.id]: [...foundItemArray, { ...item, configId: newId, quantity: 1 }] }
    return dispatch({
        type: ADD_TO_CART,
        payload: cart
    })

}

export const addToCart = item => (dispatch, getState) => {
    if (!getState().user.isAuthenticated) {
        dispatch(openAuthModal())
        return
    }


    const cart = getState().user.cart

    // start checking limits here

    let totalQty = 0
    let individualQty = 0
    let individualQtyId = ''
    for (let key in cart) {
        const itemArray = cart[key]
        let tempConfigQty = 0
        for (let i = 0; i < itemArray.length; i++) {
            const config = itemArray[i]
            const configQty = parseInt(config.quantity);
            tempConfigQty += configQty
            totalQty += configQty;
        }

        if (tempConfigQty > individualQty) {
            individualQty = tempConfigQty
            individualQtyId = key
        }

    }

    if (totalQty === 20 || (individualQty === 10 && individualQtyId === item.id)) {
        return dispatch(openBulkOrderPopUp())

    }
    // end checking limits here

    // start updating the cart locally
    dispatch(localAddToCart(item))
    // end updating the cart locally

    // dispatch(cartLoading())

    addToCartFunc({ item }).then((result) => {
        // do nothing here
    }).catch((error) => {
        if (error.message) {
            window.alert(error.message)
        } else {
            window.alert('something went wrong')
        }
        console.log(error)
    });

}


const localRemoveFromCart = ({ itemId, configId }) => (dispatch, getState) => {
    let cart = { ...getState().user.cart }

    let foundItemArray = cart[itemId] || []


    for (let i = 0; i < foundItemArray.length; i++) {
        const currentConfig = foundItemArray[i]
        if (currentConfig.configId === configId && currentConfig.quantity > 1) {
            currentConfig.quantity = currentConfig.quantity - 1
            return dispatch({
                type: REMOVE_FROM_CART,
                payload: cart
            })
        }
    }

    // id qty was 1 ..then removing it completely...
    let newItemArray = foundItemArray.filter((currentConfig) => currentConfig.configId !== configId)
    cart[itemId] = newItemArray

    // if no other items remains then remove the id completely
    if (newItemArray.length === 0) {
        delete cart[itemId]
    }

    return dispatch({
        type: REMOVE_FROM_CART,
        payload: cart
    })
}


export const removeFromCart = ({ itemId, configId }) => (dispatch, getState) => {
    if (!getState().user.isAuthenticated) {
        dispatch(openAuthModal())
        return
    }

    // start updating the cart locally
    dispatch(localRemoveFromCart({ itemId, configId }))
    // end updating the cart locally

    // dispatch(cartLoading())


    removeFromCartFunc({ itemId, configId }).then((result) => {
        // do nothing here
    }).catch((error) => {
        if (error.message) {
            window.alert(error.message)
        } else {
            window.alert('something went wrong')
        }
        console.log(error)
    });

}


export const addAddress = (address) => (dispatch, getState) => {
    const uid = getState().user.uid

    firestore.collection('user').doc(`${uid}`).set({
        addresses: firebase.firestore.FieldValue.arrayUnion(address)
    }, { merge: true }).then(() => {
        dispatch({
            type: ADD_ADDRESS
        })

    }).catch(error => {
        if (error.message) {
            window.alert(error.message)
        } else {
            window.alert('something went wrong')
        }
        console.log(error)
    })
}


export const removeAddress = (address) => (dispatch, getState) => {
    const uid = getState().user.uid

    firestore.collection('user').doc(`${uid}`).set({
        addresses: firebase.firestore.FieldValue.arrayRemove(address)
    }, { merge: true }).then(() => {
        dispatch({
            type: REMOVE_ADDRESS
        })

    }).catch(error => {
        if (error.message) {
            window.alert(error.message)
        } else {
            window.alert('something went wrong')
        }
        console.log(error)
    })
}
export const logout = () => {
    return {
        type: LOGOUT
    }
}

export const startLogout = () => (dispatch) => {

    firebase.auth().signOut().then(() => {
        dispatch(logout())
        window.location.href = '/'
    })
}
